// Configuración centralizada del entorno
const DEFAULT_DEV_API_URL = 'http://localhost:7028'
const DEFAULT_PROD_API_URL = 'https://gestion360.natgas.com.mx/backend'

const normalizeUrl = (url) => {
  if (!url) return ''
  return url.endsWith('/') ? url.slice(0, -1) : url
}

const isDevelopment = process.env.NODE_ENV === 'development'
const isProduction = process.env.NODE_ENV === 'production'

export const ENVIRONMENT = {
  IS_DEVELOPMENT: isDevelopment,
  IS_PRODUCTION: isProduction,

  get API_URL() {
    const envUrl = normalizeUrl(process.env.VUE_APP_API_URL || '')
    if (envUrl) return envUrl
    return isProduction
      ? normalizeUrl(DEFAULT_PROD_API_URL)
      : normalizeUrl(DEFAULT_DEV_API_URL)
  }
}

export default ENVIRONMENT
